//document ready
$(function () {
    /* give attribute to selector for ADA +++  validator  */
    $(".single-option-selector").attr("aria-label", "Select Variant here");
    var scrollOnClick = true;

    // Accordion product page
    $(".accordion__label").click(function () {
        var $el = $(this),
            $item = $el.closest('.accordion__item');
        $(".accordion__item").removeClass("active");
        $(".accordion__label").attr("aria-expanded", "false");
        $item.addClass('active');
        $el.attr("aria-expanded", "true");

        if (scrollOnClick) {
            var topBarsH = 0;
            if ($(".main_nav_wrapper.sticky_nav").length)
                topBarsH += $(".main_nav_wrapper.sticky_nav").outerHeight();
            if ($(".product-sticky-form.active").length)
                topBarsH += $(".product-sticky-form.active").outerHeight();

            var offset = $(window).width() > 798 && scrollOnClick ? topBarsH : 42;
            setTimeout(function () {
                goToPos($item, offset);
            }, 550);
        }
    });

    // Option select sticky form change triggers main form
    $('.product-sticky-form .single-option-selector').change(function () {
        var $el = $(this),
            dataOpt = $el.data('option'),
            val = $el.val();

        $('.product-info-container .shopify-product-form [data-option="' + dataOpt + '"]').val(val);


    });

    // Custom select for product properties (kudos to K.Statua)
    $(".product_section_container .shopify-product-form").on("mousedown", ".single-option-selector", function (event) {
        event.preventDefault();

        function animateOpenAccordion(identifier, value) {
            // animation open like accordion
            var $wrapper = $("[data-id='" + identifier + "']"),
                wrapper = $wrapper[0],
                $innerWrapper = $wrapper.find(".anim-open-accordion-wrapper"),
                heightToSet = $innerWrapper.outerHeight(true);

            $innerWrapper.find('.single-option').attr('data-sel', 0);
            $innerWrapper.find('.single-option[data-value="' + value + '"]').attr('data-sel', 1);

            wrapper.style.height = heightToSet + "px";
        }

        var $this = $(this),
            identifier = $this.attr("id"),
            dataOption = $this.data("option"),
            data = $this.find("option"),
            val = $this.val(),
            tmpl = "<span class='single-option' data-value='VALUE' data-sel='SELECTED'>TEXT</span>",
            $parent = $this.parents(".product-buy-info"),
            stringAggregator = "", // needs for collect all options
            $wrapper = $("[data-id='" + identifier + "']");

        if ($wrapper.length === 0) {
            $(data).each(function (i, el) {
                var supportString = tmpl,
                    optionVal = $(el).attr("value"),
                    optionTxt = $(el).text();
                supportString = supportString.replace("TEXT", optionTxt);
                supportString = supportString.replace("VALUE", optionVal);
                supportString = supportString.replace("SELECTED", (optionVal == val ? '1' : '0'));
                stringAggregator += supportString; // collecting options
            });

            var htmlTemplate = "<div data-id='" + identifier + "' data-option='" + dataOption + "' class='anim-open-accordion'><div class='anim-open-accordion-wrapper'>" + stringAggregator + "</div></div>"; // generating template
            $parent.after(htmlTemplate); // printing template
            $parent.addClass('with-arrow');



            animateOpenAccordion(identifier, val);
        } else {
            if ($wrapper.outerHeight(true) !== 0) {
                $wrapper.height(0);
                $parent.removeClass('with-arrow');
            } else {
                animateOpenAccordion(identifier, val);
                $parent.addClass('with-arrow');
            }
        }
    });

    $(".product_section_container").on("click", ".anim-open-accordion .single-option", function () {

        function GTM_PUSH_INFO() {
            setTimeout(
                function () {
                    if (typeof GTM.variant_sku !== 'undefined') {

                        if (typeof dataLayer == 'object') {

                            dataLayer.push({
                                'event': 'GAevent',
                                'ss_event_id': GTM.getGtmRandomString(),
                                'eventID': '31',
                                'eventCategory': 'product',
                                'eventAction': 'size',
                                'eventLabel': GTM.variant_name.replace(' ', '_'),
                                'sku': GTM.variant_sku
                            });
                        }

                    }
                }, 10);
        }

        GTM_PUSH_INFO()
        var thisValue = $(this).data("value"),
            $parent = $(this).parents(".anim-open-accordion"),
            targetSelect = $parent.data("id"),
            targetSelectDataOption = $parent.data("option"),
            $targetSelect = $("#" + targetSelect),
            $stickySelect = $('.product-sticky-form [data-option="' + targetSelectDataOption + '"]'),
            $targetSelectParent = $targetSelect.parents(".product-buy-info");

        $targetSelectParent.removeClass('with-arrow');
        $targetSelect.val(thisValue);
        $stickySelect.val(thisValue);
        $targetSelect.trigger('change');
        $parent.height(0);
    });

    // Manual refresh for product gallery.
    // Unfortunately the js navigation script doesn't have a callback for page load...
    function checkProductGallery() {

        var myInt = setInterval(function () {

            var $flickityWrapper = $('.flickity-viewport');
            var $flickityItems = $('.flickity-slider').children();
            var height = $flickityWrapper.outerHeight(true);

            if ($flickityItems.length == 0) {
                clearInterval(myInt);
            } else if (height == 0 || typeof height === 'undefined') {
                $('.js-product-gallery').flickity('resize');
            } else {
                clearInterval(myInt);
            }
        }, 1000);
    }

    checkProductGallery();

    function socialBtn() {
        var $btn = $('.social_buttons-toggler'),
            $btns = $('.social_buttons');

        $btns.slideUp(0);
        $btn.click(function () {
            $btns.slideToggle(250);
        });
    }

    socialBtn();

    $('.flickity-prev-next-button').click(function () {
        if (typeof dataLayer == 'object') {
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '33',
                'eventCategory': 'product',
                'eventAction': 'image',
                'eventLabel': GTM.image_progression,
                'sku': GTM.variant_sku
            });
        }
    });
    customGiftCard.init();
});

var customGiftCard = {
    init: function () {
        this.variantBtn();
    },
    variantBtn: function () {
        $('.gift-card__select').click(function (e) {
            e.preventDefault();
            var varID = this.getAttribute('data-id');
            var varName = this.getAttribute('data-name');
            $('select[name="id"]').val(varID).trigger('change');
            $('.single-option-selector').val(varName).trigger('change');
            $('.gift-card__select').removeClass('selected');
            $(this).addClass('selected');
        })
    }
};